export const SM_MOBILE = 384;
export const MOBILE = 512;
export const TABLET = 768;
export const DESKTOP = 1024;
export const WIDE_DESKTOP = 1152;

export function respond(size) {
  return document.documentElement.clientWidth > size
}

export function respondUntil(size) {
  return document.documentElement.clientWidth < size
}

export function onResize(cb) {
  window.addEventListener('resize', cb);
}

export function removeResize(cb) {
  window.removeEventListener('resize', cb);
}